import { SkeletonBlock } from './SkeletonBlock.tsx';

export function SkeletonInput() {
  return <SkeletonBlock className="h-9" />;
}
